document.addEventListener('DOMContentLoaded', () => {

  // ==========================================
  // G1: HANDLES ACTIVE STATES & UI INTERACTIONS
  // ==========================================

  // 1. Handle Active States for UI Grids/Rows
  function handleActiveStates(radioName, cardClass) {
    const inputs = document.querySelectorAll(`input[name="${radioName}"]`);
    
    inputs.forEach(input => {
      input.addEventListener('change', function() {
        document.querySelectorAll(`.${cardClass}`).forEach(card => {
          card.classList.remove('active');
        });
        if (this.checked) {
          this.closest(`.${cardClass}`).classList.add('active');
        }
      });
    });
  }
  
  handleActiveStates('custom_shape', 'sc-shape-card');
  handleActiveStates('custom_material', 'sc-material-card');
  handleActiveStates('custom_quantity', 'sc-qty-row');

  // 2. Auto-Select Custom Inputs Logic
  const sizeSelect = document.getElementById('custom-size-select');
  const customWidth = document.getElementById('custom_width');
  const customHeight = document.getElementById('custom_height');
  
  const customQtyRadio = document.querySelector('input[name="custom_quantity"][value="custom"]');
  const customQtyInput = document.getElementById('custom_quantity_input');
  const allQtyRadios = document.querySelectorAll('input[name="custom_quantity"]');

  // Size: Typing in width/height sets select to "Custom Size"
  if (customWidth && customHeight && sizeSelect) {
    [customWidth, customHeight].forEach(input => {
      input.addEventListener('input', () => {
        if (customWidth.value || customHeight.value) {
          sizeSelect.value = "custom";
        }
      });
    });
  }

  // Quantity: Typing in custom qty auto-selects the "Custom Quantity" radio
  if (customQtyInput && customQtyRadio) {
    customQtyInput.addEventListener('input', () => {
      if (customQtyInput.value) {
        customQtyRadio.checked = true;
        allQtyRadios.forEach(r => r.closest('.sc-qty-row').classList.remove('active'));
        customQtyRadio.closest('.sc-qty-row').classList.add('active');
      }
    });

    // Selecting a preset radio clears custom input
    allQtyRadios.forEach(radio => {
      radio.addEventListener('change', (e) => {
        if (e.target.value !== 'custom') {
          customQtyInput.value = '';
        }
      });
    });
  }
  
  // 3. Handle File Upload Label Change and Removal
  const fileInput = document.getElementById('artwork-upload');
  const uploadLabel = document.getElementById('upload-label');
  const fileNameDisplay = document.getElementById('file-name-display');
  const removeFileBtn = document.getElementById('remove-file-btn');
  
  const originalLabelHtml = uploadLabel ? uploadLabel.innerHTML : '';
  
  function resetFileUpload() {
    if(fileInput) fileInput.value = '';
    if(uploadLabel) {
      uploadLabel.innerHTML = originalLabelHtml;
      uploadLabel.classList.remove('file-selected');
    }
    if(fileNameDisplay) fileNameDisplay.innerText = 'No file chosen';
    if(removeFileBtn) removeFileBtn.style.display = 'none';
  }
  
  if(fileInput) {
    fileInput.addEventListener('change', function(e) {
      if (this.files && this.files.length > 0) {
        let fileName = this.files[0].name;
        if (fileName.length > 25) {
          fileName = fileName.substring(0, 22) + '...';
        }
        
        if(fileNameDisplay) fileNameDisplay.innerText = fileName;
        if(removeFileBtn) removeFileBtn.style.display = 'inline-block';
        
        uploadLabel.innerHTML = `
          <svg style="width: 20px; height: 20px; vertical-align: middle; margin-right: 8px; margin-top: -3px;" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path></svg>
          File Selected
        `;
        uploadLabel.classList.add('file-selected');
      } else {
        resetFileUpload();
      }
    });
  }
  
  if(removeFileBtn) {
    removeFileBtn.addEventListener('click', resetFileUpload);
  }
});
  
// ==========================================
// G2: PRICING CALCULATION & UPDATES
// ==========================================
  
// --- LOAD EXACT PRICING DATA ---
const rawPricingData = document.getElementById('sc-pricing-matrix').textContent;
const PRICING_DATA = JSON.parse(rawPricingData);
  
// --- CORE CALCULATION LOGIC ---
function calculatePrice(width, height, material, quantity) {
  const area = width * height;

  const greaterDimension = Math.min(Math.max(Math.round(width), Math.round(height), 1), 8).toString();
  
  const baseRate = PRICING_DATA.baseRates[material] || 0.084;
  
  let discountPercent = 0;
  
  // NEW: Dynamic Tiered Discount Lookup
  if (
    PRICING_DATA.discounts[material] && 
    PRICING_DATA.discounts[material][greaterDimension]
  ) {
    const discountTiers = PRICING_DATA.discounts[material][greaterDimension];
    
    // 1. Get all quantity tiers for this material/dimension as an array of numbers, sorted low to high
    const availableQuantities = Object.keys(discountTiers)
      .map(Number)
      .sort((a, b) => a - b);
    
    // 2. Loop through to find the highest tier that is <= the user's custom quantity
    let appliedTier = 0;
    for (let i = 0; i < availableQuantities.length; i++) {
      if (quantity >= availableQuantities[i]) {
        appliedTier = availableQuantities[i];
      } else {
        break; // Stop looking once the tier is larger than the user's quantity
      }
    }
    
    // 3. Apply the discount for the tier we found
    if (appliedTier > 0 && discountTiers[appliedTier.toString()] !== undefined) {
      discountPercent = discountTiers[appliedTier.toString()];
    }
  }
  
  const discountMultiplier = (100 - discountPercent) / 100;
  
  let rawOriginalTotal = area * quantity * baseRate; 
  let rawFinalTotal = area * quantity * baseRate * discountMultiplier;
  
  const originalTotal = Math.max(25.00, rawOriginalTotal);
  const finalTotal = Math.max(25.00, rawFinalTotal);
  
  const unitPrice = quantity > 0 ? (finalTotal / quantity) : 0;
  
  return {
    total: finalTotal,
    originalTotal: originalTotal, 
    unit: unitPrice,
    discount: discountPercent
  };
}
  
// --- DOM UPDATE & EVENT LISTENERS ---
document.addEventListener('DOMContentLoaded', () => {
  
  const sizeSelect = document.querySelector('select[name="custom_size"]');
  const customWidth = document.getElementById('custom_width');
  const customHeight = document.getElementById('custom_height');
  const customQtyInput = document.getElementById('custom_quantity_input');
  const finalPriceDisplay = document.getElementById('display-final-price');
  
  // Master Update Function
  function updateAllPrices() {
    if (!sizeSelect) return;

    // 1. Get Width and Height (Check if custom)
    let w = 0, h = 0;
    if (sizeSelect.value === 'custom') {
      w = parseFloat(customWidth.value) || 0;
      h = parseFloat(customHeight.value) || 0;
    } else {
      [w, h] = sizeSelect.value.split('x').map(Number);
    }
    
    // 2. Get Material
    const materialInput = document.querySelector('input[name="custom_material"]:checked');
    const material = materialInput ? materialInput.value : "Vinyl Stickers";
    
    // 3. Update Material Base Rates visually on UI
    document.querySelectorAll('.material-rate-label').forEach(label => {
      const matName = label.dataset.material;
      if (matName && PRICING_DATA.baseRates[matName]) {
        const matBaseRate = PRICING_DATA.baseRates[matName];
        const areaPrice = w * h * matBaseRate;
        label.innerText = `$${areaPrice.toFixed(2)}/ea`; 
      }
    });

    // 4. Update every Quantity Row
    const qtyRows = document.querySelectorAll('.sc-qty-row');
    qtyRows.forEach(row => {
      const radioInput = row.querySelector('input[name="custom_quantity"]');
      const unitDisplay = row.querySelector('.data-unit-price');
      const totalDisplay = row.querySelector('.data-total-price');
      const badge = row.querySelector('.data-discount-badge');
      
      let qty = 0;
      if (radioInput.value === 'custom') {
        qty = parseInt(customQtyInput.value) || 0;
      } else {
        qty = parseInt(radioInput.value);
      }
      
      if (w > 0 && h > 0 && qty > 0) {
        const pricing = calculatePrice(w, h, material, qty);
        
        if(unitDisplay) unitDisplay.innerText = `$${pricing.unit.toFixed(2)}/ea`;
        if(totalDisplay) totalDisplay.innerText = `$${pricing.total.toFixed(2)}`;
        
        if (badge) {
          if (pricing.discount > 0) {
            badge.style.display = 'inline-block';
            badge.innerText = `Save ${pricing.discount}%`;
          } else {
            badge.style.display = 'none';
          }
        }
      } else {
        // Reset to placeholder if inputs are empty
        if(unitDisplay) unitDisplay.innerText = `---`;
        if(totalDisplay) totalDisplay.innerText = `---`;
        if (badge) badge.style.display = 'none';
      }
    });
  
    // 5. Update Footer Price
    const selectedQtyInput = document.querySelector('input[name="custom_quantity"]:checked');
    if (selectedQtyInput && finalPriceDisplay) {
      let selectedQty = 0;
      if (selectedQtyInput.value === 'custom') {
        selectedQty = parseInt(customQtyInput.value) || 0;
      } else {
        selectedQty = parseInt(selectedQtyInput.value);
      }
      
      if (w > 0 && h > 0 && selectedQty > 0) {
        const finalPricing = calculatePrice(w, h, material, selectedQty);
        
        if (finalPricing.discount > 0 && finalPricing.originalTotal > finalPricing.total) {
          finalPriceDisplay.innerHTML = `
            <span style="color: #e63946;">$${finalPricing.total.toFixed(2)}</span>
            <s style="opacity: 0.6; margin-right: 10px; font-size: 0.85em;">$${finalPricing.originalTotal.toFixed(2)}</s>
          `;
        } else {
          finalPriceDisplay.innerHTML = `$${finalPricing.total.toFixed(2)}`;
        }
      } else {
         finalPriceDisplay.innerHTML = `$0.00`;
      }
    }
  }
  
  // Attach Event Listeners to ALL inputs, including the new custom text fields
  const allInputs = document.querySelectorAll(`
    select[name="custom_size"], 
    input[name="custom_material"], 
    input[name="custom_quantity"],
    input[name="custom_shape"],
    #custom_width,
    #custom_height,
    #custom_quantity_input
  `);
  
  allInputs.forEach(input => {
    if(input) input.addEventListener('input', updateAllPrices);
    if(input) input.addEventListener('change', updateAllPrices);
  });
  
  updateAllPrices();
});

// ==========================================
// G3: ADD TO CART & WORKER HANDLER
// ==========================================

const addToCartBtn = document.getElementById('add-to-cart-button');
const artworkInput = document.getElementById('artwork-upload');
  
if(addToCartBtn) {
  addToCartBtn.addEventListener('click', async (e) => {
    e.preventDefault();
    
    // 1. Gather all inputs
    const sizeDropdown = document.querySelector('select[name="custom_size"]').value;
    const material = document.querySelector('input[name="custom_material"]:checked').value;
    const qtyRadio = document.querySelector('input[name="custom_quantity"]:checked').value;
    const shapeInput = document.querySelector('input[name="custom_shape"]:checked');
    const shape = shapeInput ? shapeInput.value : 'Die Cut';
    
    // 2. Format Custom Values
    let w = 0, h = 0, sizeStr = "";
    if (sizeDropdown === 'custom') {
      w = parseFloat(document.getElementById('custom_width').value) || 0;
      h = parseFloat(document.getElementById('custom_height').value) || 0;
      sizeStr = `${w}x${h}`;
    } else {
      [w, h] = sizeDropdown.split('x').map(Number);
      sizeStr = sizeDropdown;
    }

    let qty = 0;
    if (qtyRadio === 'custom') {
      qty = parseInt(document.getElementById('custom_quantity_input').value) || 0;
    } else {
      qty = parseInt(qtyRadio);
    }

    // 3. Prevent submission if fields are blank
    if (!w || !h || !qty) {
       alert("Please ensure custom size and quantity fields are filled out correctly.");
       return;
    }

    addToCartBtn.innerText = "Processing Artwork & Cart...";
    addToCartBtn.disabled = true;

    const pricing = calculatePrice(w, h, material, qty);
  
    // 4. Payload for the WORKER
    const workerPayload = new FormData();
    workerPayload.append('productId', '10071518970157'); // Update this if your real product ID differs
    workerPayload.append('price', pricing.total);
    
    if (pricing.discount > 0 && pricing.originalTotal > pricing.total) {
      workerPayload.append('compareAtPrice', pricing.originalTotal);
    }
    
    workerPayload.append('material', material);
    workerPayload.append('shape', shape);
    workerPayload.append('size', sizeStr);
    workerPayload.append('quantity', qty);
  
    try {
      const res = await fetch('https://sticker-custom-stylecards.hasannadeem5050.workers.dev', {
        method: 'POST',
        body: workerPayload
      });
  
      const data = await res.json();
  
      if (data.variantId) {
        
        // 5. Payload for SHOPIFY CART
        const cartPayload = new FormData();
        cartPayload.append('id', data.variantId);
        cartPayload.append('quantity', 1); // Variant handles actual quantity count, so we add 1 bulk variant
        cartPayload.append('properties[Material]', material);
        cartPayload.append('properties[Shape]', shape);
        cartPayload.append('properties[Size]', sizeStr);
        cartPayload.append('properties[Quantity]', qty);
        
        if (artworkInput && artworkInput.files[0]) {
          cartPayload.append('properties[Artwork]', artworkInput.files[0]);
        } else {
          cartPayload.append('properties[Artwork]', "Email Later");
        }

        // 6. Send to Shopify Cart
        await fetch('/cart/add.js', {
          method: 'POST',
          body: cartPayload
        });
  
        addToCartBtn.innerText = "Added!";
  
        if (window.theme && window.theme.CartDrawer) {
          const cart = new window.theme.CartDrawer();
          if (cart.init) cart.init();
          if (cart.open) cart.open();
        } else {
          document.dispatchEvent(new CustomEvent('cart:build'));
          document.dispatchEvent(new CustomEvent('cart:open'));
        }
  
        setTimeout(() => {
          addToCartBtn.innerText = "Add to Cart";
          addToCartBtn.disabled = false;
        }, 2500);
  
      } else {
        throw new Error(data.error || 'Failed to create variant');
      }
    } catch (err) {
      console.error(err);
      alert('There was an issue processing your custom order.');
      addToCartBtn.innerText = "Add to Cart";
      addToCartBtn.disabled = false;
    }
  });
}